(function () {
  "use strict";
  var root = document.querySelector("[data-npx-explore]");
  if (!root) return;
  var MAX_PLAYING = parseInt(root.getAttribute("data-npx-max-playing"), 10) || 2,
    MOBILE_AUTOPLAY = root.getAttribute("data-npx-mobile-autoplay") === "true",
    HOVER_DELAY = 140,
    coarse = window.matchMedia("(hover: none)").matches,
    saveData = !!(navigator.connection && navigator.connection.saveData),
    FULL_KEY = "northpix-explore-full",
    fullMode = !1;
  try {
    var savedFull = localStorage.getItem(FULL_KEY);
    savedFull !== null
      ? (fullMode = savedFull === "1")
      : (fullMode = (window.innerWidth || 1200) < 750);
  } catch (e) {
    fullMode = (window.innerWidth || 1200) < 750;
  }
  function autoMode() {
    return fullMode || (coarse && MOBILE_AUTOPLAY);
  }
  function hoverOn() {
    return !coarse && !fullMode;
  }
  (function () {
    var st = document.createElement("style");
    st.setAttribute("data-npx-acts-scale", ""),
      (st.textContent =
        ".npx-tile{container-type:inline-size}@container (max-width:150px){.npx-tile .npx-acts{padding:4px;gap:4px;justify-content:flex-end}.npx-tile .npx-acts .npx-acts__by{display:none}.npx-tile .npx-acts .npx-act{height:24px;min-width:24px;padding:0 5px;gap:0}.npx-tile .npx-acts .npx-act svg{width:12px;height:12px}.npx-tile .npx-acts .npx-act--save{min-width:24px;padding:0 5px}.npx-tile .npx-acts .npx-act--save span{display:none}.npx-tile .npx-acts .npx-act--save svg{display:block}}@container (max-width:118px){.npx-tile .npx-acts{padding:3px}.npx-tile .npx-acts .npx-act:not(.npx-act--save){display:none}.npx-tile .npx-acts .npx-act{height:20px;min-width:20px;padding:0 4px}.npx-tile .npx-acts .npx-act svg{width:11px;height:11px}}"),
      document.head.appendChild(st);
  })();
  function mulberry32(a) {
    return function () {
      (a |= 0), (a = (a + 1831565813) | 0);
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      return (
        (t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t), ((t ^ (t >>> 14)) >>> 0) / 4294967296
      );
    };
  }
  function daySeed() {
    var s = parseInt(root.getAttribute("data-npx-seed"), 10);
    if (s) return s;
    var d = new Date();
    return d.getFullYear() * 1e4 + (d.getMonth() + 1) * 100 + d.getDate();
  }
  function shuffleBatch(container, nodes, saltIndex) {
    if (nodes.length) {
      for (
        var rnd = mulberry32(daySeed() + saltIndex * 7919), arr = nodes.slice(), i = arr.length - 1;
        i > 0;
        i--
      ) {
        var j = Math.floor(rnd() * (i + 1)),
          tmp = arr[i];
        (arr[i] = arr[j]), (arr[j] = tmp);
      }
      var frag = document.createDocumentFragment();
      arr.forEach(function (n) {
        frag.appendChild(n);
      }),
        container.appendChild(frag);
    }
  }
  var batchIndex = 0,
    grid = root.querySelector("[data-npx-grid]"),
    order = grid ? Array.prototype.slice.call(grid.children) : [];
  function ratioOf(tile) {
    var r = parseFloat(tile.getAttribute("data-npx-ratio"));
    return r > 0 ? r : 1.5;
  }

  /* ---------- Rutnätet: justerade rader (ersätter masonry-kolumnerna, 2026-10-18) ----------
     Rutorna ligger i div.npx-row. Varje li får --a (proportionen ur data-npx-ratio) och CSS ger
     den flex-grow och aspect-ratio efter --a, så i en hel rad får alla rutor samma höjd och
     raden fyller bredden utan JS-mått (och skalar med bredden). JS räknar bara var raderna
     bryts (layoutRows) mot målhöjden. Sista raden är öppen (.npx-row--open) och står kvar i
     målhöjden --h; en ny sida packar bara om den, raderna ovanför rörs inte.
     Förlaga: arkivets FA.justeraRader (VideoAnalysGX10/gx10/index.template.html). */
  var ROW_MIN = 140,
    ROW_MIN_NARROW = 120,
    ROW_MAX = 380,
    ROW_STEP = 5,
    ROW_BTN_STEP = 40,
    FULL_STOP = ROW_MAX + ROW_STEP, // reglagets sista stopp: ett klipp per rad (fullMode)
    TILE_MIN_W = 150, // ingen ruta smalare än så: raden bryts tidigare i stället
    ASPECT_MIN = 0.25,
    ASPECT_MAX = 4,
    ROWH_KEY = "northpix-explore-rowh",
    rowH = { d: 220, m: 120 }; // målhöjd desktop (Jacob 2026-10-18) och telefon
  try {
    var savedD = parseInt(localStorage.getItem(ROWH_KEY), 10),
      savedM = parseInt(localStorage.getItem(ROWH_KEY + "-m"), 10);
    savedD >= ROW_MIN && savedD <= ROW_MAX && (rowH.d = savedD);
    savedM >= ROW_MIN_NARROW && savedM <= ROW_MAX && (rowH.m = savedM);
  } catch (e) {}
  function narrow() {
    return (window.innerWidth || 1200) < 750;
  }
  function rowMin() {
    return narrow() ? ROW_MIN_NARROW : ROW_MIN;
  }
  function targetH() {
    return rowH[narrow() ? "m" : "d"];
  }
  function aspectOf(tile) {
    return Math.max(ASPECT_MIN, Math.min(ASPECT_MAX, ratioOf(tile)));
  }

  // Radbrytningen. a: proportionerna i ordning, W: radbredd, H: målhöjd, gap: mellanrum, minW: minsta rutbredd.
  // Ger [{n, h, full, cap}]. Kortaste väg över brytpunkterna där kostnaden är kvadraten på radens relativa
  // avvikelse från H (arkivets metod). En rad med flera rutor får inte bli högre än 2,5 H, och ingen ruta i
  // den får bli smalare än minW (då bryts raden före). En ensam ruta är alltid tillåten; blir den högre än
  // 2,5 H står den i den höjden utan att sträckas (cap). Svansen som inte fyller en rad blir en öppen rad i
  // målhöjd, höjd bara så mycket att ingen ruta blir smalare än minW.
  function layoutRows(a, W, H, gap, minW) {
    var N = a.length,
      out = [],
      HMAX = H * 2.5,
      HMIN = H * 0.4,
      MAXN = 60,
      cost = [],
      from = [],
      i,
      j;
    if (!N || !(W > 0) || !(H > 0)) return out;
    minW = Math.min(minW, W);
    for (i = 0; i <= N; i++) cost.push(Infinity), from.push(-1);
    cost[0] = 0;
    for (i = 0; i < N; i++) {
      if (cost[i] === Infinity) continue;
      for (var s = 0, mn = Infinity, j = i; j < N && j - i < MAXN; j++) {
        (s += a[j]), (mn = Math.min(mn, a[j]));
        var h = (W - gap * (j - i)) / s;
        if (j > i && h * mn < minW) break; // en ruta skulle bli för smal: raden bryts före
        if (j > i && h > HMAX) continue; // för hög rad med flera rutor: ta med en ruta till
        var d = (Math.min(h, HMAX) - H) / H,
          k = cost[i] + d * d;
        k < cost[j + 1] - 1e-12 && ((cost[j + 1] = k), (from[j + 1] = i));
        if (h < HMIN) break;
      }
    }
    // svansen: rutorna sist som inte fyller en rad får bli en öppen rad utan kostnad
    var start = N,
      best = cost[N],
      st = 0,
      smn = Infinity,
      hOpen = H;
    for (i = N - 1; i >= 0; i--) {
      (st += a[i]), (smn = Math.min(smn, a[i]));
      var hh = Math.max(H, minW / smn);
      if (st * hh + gap * (N - 1 - i) >= W) break;
      cost[i] < best && ((best = cost[i]), (start = i), (hOpen = hh));
    }
    for (var end = start, rev = []; end > 0; ) {
      var b = from[end],
        sm = 0;
      for (j = b; j < end; j++) sm += a[j];
      var hr = (W - gap * (end - b - 1)) / sm;
      rev.push(hr > HMAX ? { n: end - b, h: HMAX, full: !0, cap: !0 } : { n: end - b, h: hr, full: !0 });
      end = b;
    }
    for (i = rev.length - 1; i >= 0; i--) out.push(rev[i]);
    start < N && out.push({ n: N - start, h: hOpen, full: !1 });
    return out;
  }

  var rows = [], // [{el, start, n, h, full, cap}] i ordning
    laidW = 0,
    laidH = 0,
    laidFull = null,
    sizesTimer = null;
  function gridWidth() {
    return grid.getBoundingClientRect().width;
  }
  function gapPx() {
    var g = parseFloat(getComputedStyle(grid).getPropertyValue("--npx-gap"));
    return g > 0 ? g : 0;
  }
  // Lägger rutorna från rad ri och framåt. Rader före ri rörs inte. Flyttar bara de rutor som byter plats.
  function layoutFrom(ri) {
    var W = gridWidth();
    if (!(W > 0)) return !1;
    ri = Math.min(ri, rows.length);
    var start = ri < rows.length ? rows[ri].start : ri ? rows[ri - 1].start + rows[ri - 1].n : 0,
      tiles = order.slice(start),
      H = targetH(),
      a = tiles.map(aspectOf),
      plan = fullMode
        ? a.map(function (x) {
            return { n: 1, h: W / x, full: !0 };
          })
        : layoutRows(a, W, H, gapPx(), TILE_MIN_W);
    grid.classList.add("is-packed");
    for (var k = 0, p = 0; p < plan.length; p++, ri++) {
      var r = plan[p],
        row = rows[ri];
      if (!row) {
        var el = document.createElement("div");
        el.setAttribute("role", "none"), grid.appendChild(el), (row = rows[ri] = { el: el });
      }
      (row.start = start + k), (row.n = r.n), (row.h = r.h), (row.full = r.full), (row.cap = !!r.cap);
      var cls = "npx-row" + (r.full ? (r.cap ? " npx-row--cap" : "") : " npx-row--open"),
        hv = r.h.toFixed(2) + "px";
      row.el.className !== cls && (row.el.className = cls);
      row.el.style.getPropertyValue("--h") !== hv && row.el.style.setProperty("--h", hv);
      for (var j = 0; j < r.n; j++, k++) {
        var t = tiles[k],
          av = a[k].toFixed(4);
        t.__npxA !== av && (t.style.setProperty("--a", av), (t.__npxA = av));
        row.el.children[j] !== t && row.el.insertBefore(t, row.el.children[j] || null);
      }
    }
    for (var x = rows.length - 1; x >= ri; x--) rows[x].el.remove();
    return (rows.length = ri), (laidW = W), (laidH = H), (laidFull = fullMode), !0;
  }
  // sizes på bilderna = rutans bredd i px (efter radbrytningen). Fördröjs under reglagedrag så att
  // webbläsaren inte hämtar en ny storlek per bildruta.
  function applySizes() {
    sizesTimer = null;
    for (var r = 0; r < rows.length; r++)
      for (var row = rows[r], kids = row.el.children, j = 0; j < kids.length; j++) {
        var t = kids[j],
          im = t.__npxImg;
        if (im === void 0) im = t.__npxImg = t.querySelector(".npx-card__img[srcset]");
        if (im) {
          var w = fullMode ? laidW : Math.min(laidW, parseFloat(t.__npxA) * row.h),
            val = Math.ceil(w) + "px";
          im.sizes !== val && (im.sizes = val);
        }
      }
  }
  function scheduleSizes(now) {
    clearTimeout(sizesTimer), now ? applySizes() : (sizesTimer = setTimeout(applySizes, 250));
  }
  // Scrollankring: kortet överst i den synliga ytan (under den fastnade verktygsraden) ligger kvar på samma
  // ställe i fönstret när radhöjderna ändras. Kortet och dess läge sparas när besökaren scrollar och efter
  // varje omradbrytning; har besökaren inte scrollat sedan dess (en dragning i reglaget, ett fönster som
  // ändrar storlek) behålls samma kort och samma läge, så att en dragning fram och tillbaka slutar där den
  // började. Rutnätet håller sin höjd under bytet så att scrollen inte kläms mot sidans slut innan
  // kompensationen. (overflow-anchor är av på rutnätet: webbläsarens egen ankring blandas inte in.)
  var anchorMemo = null;
  function anchorTile() {
    if (window.pageYOffset <= 0 || !rows.length) return null;
    var vt = bar ? Math.max(0, bar.getBoundingClientRect().bottom) : 0; // under den klistrade verktygsraden
    // första raden vars underkant ligger under vt (raderna ligger i ordning: binärsökning)
    for (var lo = 0, hi = rows.length - 1; lo < hi; ) {
      var mid = (lo + hi) >> 1;
      rows[mid].el.getBoundingClientRect().bottom > vt + 1 ? (hi = mid) : (lo = mid + 1);
    }
    var rc = rows[lo].el.getBoundingClientRect();
    return rc.bottom > vt + 1 && rc.top < window.innerHeight ? rows[lo].el.firstElementChild : null;
  }
  function rememberAnchor() {
    var m = anchorMemo;
    if (m && m.tile.isConnected && Math.abs(window.pageYOffset - m.scrollY) < 1) return; // vår egen scrollBy
    var t = anchorTile();
    anchorMemo = t ? { tile: t, y: t.getBoundingClientRect().top, scrollY: window.pageYOffset } : null;
  }
  // Bredden har ändrats och CSS har skalat raderna: håll kortet kvar direkt, före den fördröjda omradbrytningen.
  function holdAnchor() {
    var m = anchorMemo;
    if (m && m.tile.isConnected) {
      var d = m.tile.getBoundingClientRect().top - m.y;
      Math.abs(d) >= 0.5 && window.scrollBy(0, d), (m.scrollY = window.pageYOffset);
    }
  }
  function withAnchor(fn) {
    var m = anchorMemo,
      ref = null,
      y0 = 0;
    m && m.tile.isConnected && Math.abs(window.pageYOffset - m.scrollY) < 1
      ? ((ref = m.tile), (y0 = m.y))
      : (ref = anchorTile()) && (y0 = ref.getBoundingClientRect().top);
    ref && (grid.style.minHeight = grid.offsetHeight + "px");
    var res = fn();
    if (ref) {
      var d = ref.getBoundingClientRect().top - y0;
      Math.abs(d) >= 0.5 && window.scrollBy(0, d), (grid.style.minHeight = "");
      (d = ref.getBoundingClientRect().top - y0), Math.abs(d) >= 0.5 && window.scrollBy(0, d);
      anchorMemo = { tile: ref, y: y0, scrollY: window.pageYOffset };
    } else anchorMemo = null;
    return res;
  }
  function layoutAll() {
    grid && (withAnchor(function () {
      return layoutFrom(0);
    }), scheduleSizes(!0), syncDensity());
  }
  function relayout() {
    grid && (withAnchor(function () {
      return layoutFrom(0);
    }), scheduleSizes(!1), syncDensity());
  }
  // En ny sida: bara den öppna sista raden packas om tillsammans med de nya rutorna.
  function appendTiles(nodes) {
    nodes.forEach(function (t) {
      order.push(t);
    });
    var ri = rows.length;
    ri && !rows[ri - 1].full && ri--;
    var ok = withAnchor(function () {
      return layoutFrom(ri);
    });
    ok
      ? scheduleSizes(!0)
      : nodes.forEach(function (t) {
          grid.appendChild(t);
        });
  }

  var density = root.querySelector("[data-npx-density]"),
    sizeSlider = density ? density.querySelector("[data-npx-size]") : null;
  function currentStop() {
    return fullMode ? FULL_STOP : targetH();
  }
  function syncDensity() {
    if (density) {
      density.hidden = !1;
      var v = currentStop(),
        mn = rowMin();
      sizeSlider &&
        ((sizeSlider.min = String(mn)),
        (sizeSlider.max = String(FULL_STOP)),
        (sizeSlider.step = String(ROW_STEP)),
        (sizeSlider.value = String(v)),
        sizeSlider.setAttribute("aria-valuetext", fullMode ? "Ett klipp per rad" : "Radhöjd " + v + " px"));
      var minus = density.querySelector('[data-npx-size-step="-1"]'),
        plus = density.querySelector('[data-npx-size-step="1"]');
      minus && (minus.disabled = !fullMode && v <= mn), plus && (plus.disabled = fullMode);
    }
  }
  // Reglagets värde är målhöjden i px; sista stoppet (FULL_STOP) är ett klipp per rad som förut.
  function setStop(v) {
    if (((v = parseInt(v, 10)), !(v > 0))) {
      syncDensity();
      return;
    }
    if (v >= FULL_STOP) {
      if (fullMode) {
        syncDensity();
        return;
      }
      (fullMode = !0), applyFull(!0), relayout();
      return;
    }
    v = Math.min(Math.max(Math.round(v / ROW_STEP) * ROW_STEP, rowMin()), ROW_MAX);
    if (!fullMode && v === targetH()) {
      syncDensity();
      return;
    }
    fullMode && ((fullMode = !1), applyFull(!0)), (rowH[narrow() ? "m" : "d"] = v);
    try {
      localStorage.setItem(ROWH_KEY + (narrow() ? "-m" : ""), String(v));
    } catch (err) {}
    relayout();
  }
  function setVw() {
    var w = document.documentElement.clientWidth;
    w > 0 ? root.style.setProperty("--npx-vw", w + "px") : root.style.removeProperty("--npx-vw");
  }
  function applyFull(persist) {
    if ((setVw(), root.classList.toggle("npx-explore--full", fullMode), persist))
      try {
        localStorage.setItem(FULL_KEY, fullMode ? "1" : "0");
      } catch (e) {}
    (MAX_PLAYING = fullMode ? 1 : parseInt(root.getAttribute("data-npx-max-playing"), 10) || 2),
      autoMode() ? ensureIO() : teardownIO();
  }
  if (
    (density &&
      density.addEventListener("click", function (e) {
        var b = e.target.closest("[data-npx-size-step]");
        if (!b || b.disabled) return;
        parseInt(b.getAttribute("data-npx-size-step"), 10) > 0
          ? setStop(targetH() >= ROW_MAX || fullMode ? FULL_STOP : Math.min(targetH() + ROW_BTN_STEP, ROW_MAX))
          : setStop(fullMode ? ROW_MAX : Math.max(targetH() - ROW_BTN_STEP, rowMin()));
      }),
    sizeSlider)
  ) {
    // rAF-dämpning: under drag räknas raderna om högst en gång per bildruta, med det senaste värdet.
    var slideRaf = 0,
      slideVal = null,
      onSlide = function () {
        (slideVal = sizeSlider.value),
          slideRaf ||
            (slideRaf = requestAnimationFrame(function () {
              (slideRaf = 0), setStop(slideVal);
            }));
      };
    sizeSlider.addEventListener("input", onSlide), sizeSlider.addEventListener("change", onSlide);
  }
  if ((applyFull(!1), grid)) {
    grid.getAttribute("data-npx-shuffle") === "daily" &&
      (shuffleBatch(grid, order, batchIndex++),
      (order = Array.prototype.slice.call(grid.children))),
      layoutAll();
    // Ny packning när rutnätets bredd ändras (fönstret, filterspalten) eller målhöjden byts mellan
    // telefon och dator. Däremellan skalar CSS raderna med bredden.
    var rzTimer = null,
      needsLayout = function () {
        return (
          Math.abs(gridWidth() - laidW) >= 1 ||
          fullMode !== laidFull ||
          (!fullMode && targetH() !== laidH)
        );
      };
    window.addEventListener("resize", function () {
      clearTimeout(rzTimer),
        (rzTimer = setTimeout(function () {
          setVw(), needsLayout() ? relayout() : syncDensity();
        }, 180));
    });
    window.addEventListener("scroll", rememberAnchor, { passive: !0 });
    if ("ResizeObserver" in window) {
      var roTimer = null,
        roW = gridWidth();
      new ResizeObserver(function () {
        var w = gridWidth();
        Math.abs(w - roW) >= 0.5 && ((roW = w), holdAnchor()),
          clearTimeout(roTimer),
          (roTimer = setTimeout(function () {
            needsLayout() && relayout();
          }, 180));
      }).observe(grid);
    }
  }
  var playing = [];
  function stop(card) {
    var v = card.__npxVideo;
    if ((card.classList.remove("is-playing"), v))
      try {
        v.pause();
      } catch (e) {}
    var i = playing.indexOf(card);
    i > -1 && playing.splice(i, 1);
  }
  function trim() {
    for (; playing.length > MAX_PLAYING; ) stop(playing[0]);
  }
  var VIDEO_CACHE = 12,
    made = [];
  function destroy(card) {
    var v = card.__npxVideo;
    if (v) {
      stop(card), v.removeAttribute("src");
      try {
        v.load();
      } catch (e) {}
      v.parentNode && v.parentNode.removeChild(v), (card.__npxVideo = null);
    }
  }
  function start(card) {
    var src = card.getAttribute("data-npx-preview");
    if (!(!src || saveData)) {
      var v = card.__npxVideo;
      if (!v)
        for (
          v = document.createElement("video"),
            v.className = "npx-card__video",
            v.muted = !0,
            v.loop = !0,
            v.playsInline = !0,
            v.setAttribute("muted", ""),
            v.setAttribute("playsinline", ""),
            v.setAttribute("preload", "none"),
            v.setAttribute("disableremoteplayback", ""),
            v.setAttribute("tabindex", "-1"),
            v.setAttribute("aria-hidden", "true"),
            v.src = src,
            card.appendChild(v),
            card.__npxVideo = v,
            v.addEventListener("error", function () {
              card.removeAttribute("data-npx-preview"), stop(card);
            }),
            made.push(card);
          made.length > VIDEO_CACHE;

        ) {
          var old = made.shift();
          old !== card && playing.indexOf(old) === -1 && destroy(old);
        }
      playing.indexOf(card) === -1 && playing.push(card), trim();
      var p = v.play();
      p &&
        p.catch &&
        p.catch(function () {
          stop(card);
        }),
        card.classList.add("is-playing");
    }
  }
  var hoverTimer = null,
    hoverCard = null;
  function onOver(e) {
    if (hoverOn()) {
      var card = e.target.closest ? e.target.closest(".npx-card[data-npx-preview]") : null;
      !card ||
        card === hoverCard ||
        (hoverCard && stop(hoverCard),
        (hoverCard = card),
        clearTimeout(hoverTimer),
        (hoverTimer = setTimeout(function () {
          hoverCard === card && start(card);
        }, HOVER_DELAY)));
    }
  }
  function onOut(e) {
    if (hoverOn()) {
      var card = e.target.closest ? e.target.closest(".npx-card") : null;
      card &&
        ((e.relatedTarget && card.contains(e.relatedTarget)) ||
          (clearTimeout(hoverTimer), hoverCard === card && (hoverCard = null), stop(card)));
    }
  }
  root.addEventListener("mouseover", onOver, !0),
    root.addEventListener("mouseout", onOut, !0),
    window.addEventListener("pagehide", function () {
      playing.slice().forEach(stop);
    });
  var io = null,
    visible = new Map();
  function ioCallback(entries) {
    if (
      (entries.forEach(function (en) {
        en.intersectionRatio > 0.55
          ? visible.set(en.target, en.intersectionRatio)
          : visible.delete(en.target);
      }),
      !!autoMode())
    ) {
      var best = null,
        bestR = 0;
      visible.forEach(function (r, el) {
        r > bestR && ((bestR = r), (best = el));
      }),
        playing.slice().forEach(function (c) {
          c !== best && stop(c);
        }),
        best && start(best);
    }
  }
  function ensureIO() {
    io ||
      saveData ||
      !("IntersectionObserver" in window) ||
      ((io = new IntersectionObserver(ioCallback, { threshold: [0, 0.55, 0.9] })), observe(root));
  }
  function teardownIO() {
    io && (io.disconnect(), (io = null), visible.clear(), playing.slice().forEach(stop));
  }
  function observe(scope) {
    if (io)
      for (
        var list = scope.querySelectorAll(".npx-card[data-npx-preview]"), i = 0;
        i < list.length;
        i++
      )
        io.observe(list[i]);
  }
  autoMode() && ensureIO();
  var form = root.querySelector("[data-npx-facets]"),
    side = root.querySelector("[data-npx-side]"),
    toggle = root.querySelector("[data-npx-filters-toggle]"),
    scrim = root.querySelector("[data-npx-scrim]"),
    closeBtn = root.querySelector("[data-npx-side-close]"),
    filterN = root.querySelector("[data-npx-filter-n]"),
    wide = window.matchMedia("(min-width: 1000px)");
  function drawerMode() {
    return !wide.matches;
  }
  function setDrawer(open) {
    side &&
      (side.classList.toggle("is-open", open),
      scrim && (scrim.hidden = !open),
      toggle && toggle.setAttribute("aria-expanded", String(open)),
      document.documentElement.classList.toggle("npx-lock", open),
      open && closeBtn && closeBtn.focus(),
      !open &&
        toggle &&
        document.activeElement &&
        side.contains(document.activeElement) &&
        toggle.focus());
  }
  function syncGroups() {
    if (side)
      for (var groups = side.querySelectorAll("details.npx-facet"), i = 0; i < groups.length; i++)
        wide.matches
          ? (groups[i].open = !0)
          : groups[i].hasAttribute("data-npx-keep") || (groups[i].open = !1);
  }
  function pendingCount() {
    return side ? side.querySelectorAll('input[type="checkbox"]:checked').length : 0;
  }
  function showPending() {
    if (filterN) {
      var n = pendingCount();
      (filterN.textContent = " (" + n + ")"), (filterN.hidden = n === 0);
    }
  }
  side &&
    (syncGroups(),
    wide.addEventListener &&
      wide.addEventListener("change", function () {
        wide.matches && setDrawer(!1), syncGroups();
      }),
    toggle &&
      toggle.addEventListener("click", function () {
        setDrawer(!side.classList.contains("is-open"));
      }),
    closeBtn &&
      closeBtn.addEventListener("click", function () {
        setDrawer(!1);
      }),
    scrim &&
      scrim.addEventListener("click", function () {
        setDrawer(!1);
      }),
    document.addEventListener("keydown", function (e) {
      e.key === "Escape" && side.classList.contains("is-open") && setDrawer(!1);
    }));
  function submitForm() {
    form && (form.requestSubmit ? form.requestSubmit() : form.submit());
  }
  form &&
    (root.addEventListener("change", function (e) {
      var t = e.target;
      if (t.matches && t.matches("[data-npx-sort]")) {
        submitForm();
        return;
      }
      if (t.type === "checkbox" && t.form === form) {
        var chip = t.closest(".npx-chip");
        chip && chip.classList.toggle("is-active", t.checked),
          showPending(),
          drawerMode() || submitForm();
      }
    }),
    form.addEventListener("submit", function () {
      Array.prototype.forEach.call(form.elements, function (el) {
        (el.type === "search" || el.tagName === "SELECT") && el.value === "" && (el.disabled = !0);
      });
    }));
  var bar = root.querySelector(".npx-bar"),
    barSentinel = root.querySelector("[data-npx-bar-sentinel]"),
    barStuck = !1;
  function setBarStuck(on) {
    if (!(!bar || on === barStuck)) {
      var anchor = grid || bar,
        top0 = anchor.getBoundingClientRect().top,
        y0 = window.pageYOffset;
      (barStuck = on), bar.classList.toggle("npx-bar--stuck", on);
      var top1 = anchor.getBoundingClientRect().top,
        shift = on ? Math.max(0, top0 + y0 - (top1 + window.pageYOffset)) : 0;
      barSentinel && (barSentinel.style.transform = shift ? "translateY(" + -shift + "px)" : ""),
        top1 !== top0 && (on || y0 > 0) && window.scrollBy(0, top1 - top0);
    }
  }
  if (bar && barSentinel && "IntersectionObserver" in window) {
    root.style.overflowAnchor = "none";
    var barTop = parseFloat(getComputedStyle(bar).top) || 0,
      stickIO = new IntersectionObserver(
        function (entries) {
          var en = entries[entries.length - 1];
          setBarStuck(!en.isIntersecting);
        },
        { rootMargin: -Math.round(barTop) + "px 0px 0px 0px", threshold: 0 },
      );
    stickIO.observe(barSentinel);
  }
  var moreWrap = null,
    moreBtn = null,
    INFINITE = root.getAttribute("data-npx-infinite") === "true",
    AUTO_PAGES = parseInt(root.getAttribute("data-npx-auto-pages"), 10) || 0,
    autoLeft = 0,
    loading = !1,
    sentinelIO = null,
    gen = 0; // ökas när resultatet byts (ersatt): en nästa sida ur det gamla resultatet läggs då inte till
  var laddade = 0; // antal nästa-sidor som lagts till, för minnet nedan
  function finishInfinite() {
    (autoLeft = 0),
      sentinelIO && (sentinelIO.disconnect(), (sentinelIO = null)),
      moreWrap && moreWrap.classList.remove("npx-more--auto");
  }
  function loadNext() {
    if (!moreBtn || loading) return Promise.resolve(!1);
    var url = moreBtn.getAttribute("data-npx-next");
    if (!url) return Promise.resolve(!1);
    var g = gen;
    (loading = !0), (moreBtn.disabled = !0);
    var label = moreBtn.getAttribute("data-npx-label") || moreBtn.textContent;
    return (
      moreBtn.setAttribute("data-npx-label", label),
      (moreBtn.textContent = "…"),
      fetch(url, { headers: { "X-Requested-With": "fetch" } })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          if (g !== gen) return !1;
          var doc = new DOMParser().parseFromString(html, "text/html"),
            nextGrid = doc.querySelector("[data-npx-grid]"),
            nextBtn = doc.querySelector("[data-npx-more]");
          if (nextGrid && grid) {
            var nodes = Array.prototype.slice.call(nextGrid.children);
            if (grid.getAttribute("data-npx-shuffle") === "daily") {
              var tmp = document.createElement("div");
              shuffleBatch(tmp, nodes, batchIndex++),
                (nodes = Array.prototype.slice.call(tmp.children));
            }
            appendTiles(nodes), observe(grid), laddade++;
          }
          return (
            (loading = !1),
            nextBtn && nextBtn.getAttribute("data-npx-next")
              ? (moreBtn.setAttribute("data-npx-next", nextBtn.getAttribute("data-npx-next")),
                moreBtn.setAttribute("href", nextBtn.getAttribute("data-npx-next")),
                (moreBtn.disabled = !1),
                (moreBtn.textContent = label),
                !0)
              : (finishInfinite(), moreWrap && moreWrap.remove(), (moreWrap = moreBtn = null), !1)
          );
        })
        .catch(function () {
          if (g !== gen) return !1;
          return (
            (loading = !1),
            finishInfinite(),
            moreBtn &&
              ((moreBtn.disabled = !1),
              (moreBtn.textContent = moreBtn.getAttribute("data-npx-label") || "Visa fler")),
            !1
          );
        })
    );
  }
  // Nästa-länken: klick laddar in nästa sida här, och de första sidorna laddas automatiskt vid scroll.
  // Egen funktion sedan 2026-10-19 så att en ny länk kan kopplas in när resultatet byts (ersatt).
  function bindMore(wrap) {
    finishInfinite();
    moreWrap = wrap || null;
    moreBtn = wrap ? wrap.querySelector("[data-npx-more]") : null;
    autoLeft = INFINITE ? AUTO_PAGES : 0;
    if (!moreBtn) return;
    moreBtn.addEventListener("click", function (e) {
      /* Nästa-länken är en riktig <a href> för Google (agent 5); med JS laddas sidan in här i stället för sidbyte. */
      e.preventDefault();
      loadNext();
    });
    INFINITE &&
      autoLeft > 0 &&
      "IntersectionObserver" in window &&
      (moreWrap.classList.add("npx-more--auto"),
      (sentinelIO = new IntersectionObserver(
        function (entries) {
          entries.some(function (e) {
            return e.isIntersecting;
          }) &&
            (loading ||
              autoLeft <= 0 ||
              (autoLeft--,
              loadNext().then(function (more) {
                if (!more || autoLeft <= 0) return finishInfinite();
                /* Vakten säger bara till när knappen går in i eller ut ur zonen. Ligger den kvar i zonen efter
                   laddningen (startsidan, 2026-10-22) kom ingen ny signal och laddningen stannade: titta om. */
                sentinelIO && moreWrap && (sentinelIO.unobserve(moreWrap), sentinelIO.observe(moreWrap));
              })));
        },
        { rootMargin: "800px 0px" },
      )),
      sentinelIO.observe(moreWrap));
  }
  bindMore(root.querySelector(".npx-more"));

  /* ---------- Byt resultat på plats (2026-10-19) ----------
     ersatt(doc) tar ett dokument med samma sektion (hämtat med fetch och DOMParser, se npx-pa-plats.js som bara
     körs på startsidan) och byter rutnätets rutor, antalet och nästa-länken. Förhandsvisningarna stoppas, raderna
     packas från början och den dagliga blandningen görs om med samma frö som vid laddning, så resultatet blir
     detsamma som om sidan hade laddats på adressen. Facetterna i spalten byts inte här. Ger antalet rutor, eller
     -1 när sidan saknar rutnät (då får anroparen ladda om sidan i stället). */
  var tomEl = null;
  function ersatt(doc) {
    if (!grid || !doc) return -1;
    gen++, (loading = !1), (laddade = 0);
    clearTimeout(hoverTimer), (hoverCard = null);
    playing.slice().forEach(stop), made.slice().forEach(destroy), (made = []);
    io && (io.disconnect(), (io = null), visible.clear());
    var nextGrid = doc.querySelector("[data-npx-grid]"),
      nodes = nextGrid ? Array.prototype.slice.call(nextGrid.children) : [],
      sh = nextGrid ? nextGrid.getAttribute("data-npx-shuffle") : null;
    sh ? grid.setAttribute("data-npx-shuffle", sh) : grid.removeAttribute("data-npx-shuffle");
    for (var r = 0; r < rows.length; r++) rows[r].el.remove();
    for (rows.length = 0; grid.firstChild; ) grid.removeChild(grid.firstChild);
    (order = []), (batchIndex = 0), (anchorMemo = null);
    if (sh === "daily" && nodes.length) {
      var tmp = document.createElement("div");
      shuffleBatch(tmp, nodes, batchIndex++), (nodes = Array.prototype.slice.call(tmp.children));
    }
    // Tomt resultat: rutnätet döljs och sidans egen tomtext visas i stället.
    grid.style.display = nodes.length ? "" : "none";
    if (nodes.length) tomEl && (tomEl.hidden = !0);
    else {
      var ne = doc.querySelector(".npx-empty");
      tomEl || ((tomEl = document.createElement("p")), (tomEl.className = "npx-empty"), grid.parentNode.insertBefore(tomEl, grid));
      (tomEl.textContent = ne ? ne.textContent : ""), (tomEl.hidden = !1);
    }
    order = nodes;
    layoutFrom(0)
      ? scheduleSizes(!0)
      : nodes.forEach(function (t) {
          grid.appendChild(t);
        });
    syncDensity();
    var c = root.querySelector(".npx-count"),
      nc = doc.querySelector(".npx-count");
    c && nc && (c.textContent = nc.textContent);
    var nextMore = doc.querySelector(".npx-more");
    moreWrap && moreWrap.remove(), nextMore && grid.insertAdjacentElement("afterend", nextMore);
    bindMore(nextMore);
    autoMode() && ensureIO();
    return nodes.length;
  }
  /* ---------- Minnet: tillbaka till samma ställe (Jacob 2026-10-22) ----------
     Rutnätet laddar fler sidor medan man skrollar. Laddas sidan om (bakåt utan bfcache, eller omladdning) finns bara
     första sidan, och webbläsarens skrollposition pekar på rutor som inte finns. Därför sparas antalet laddade
     sidor och rutan överst i fönstret (handle och avstånd) i sessionStorage när man lämnar sidan eller klickar på
     ett kort. Vid återkomst till samma adress laddas lika många sidor igen och rutan läggs på samma höjd.
     Produktpanelen (npx-produktpanel.js) gör det här onödigt i det vanliga fallet, det här är skyddsnätet. */
  var MINNE_RUTNAT = "npx-rutnat-minne";
  function minnesUrl() { return location.pathname + location.search; }
  function toppHojd() {
    var h = document.querySelector("store-header, .header");
    return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
  }
  function ankare(kort) {
    if (!kort && grid) {
      var lim = toppHojd(), list = grid.querySelectorAll(".npx-card[data-npx-handle]");
      for (var i = 0; i < list.length; i++) {
        if (list[i].getBoundingClientRect().bottom > lim + 8) { kort = list[i]; break; }
      }
    }
    return kort ? { h: kort.getAttribute("data-npx-handle"), o: Math.round(kort.getBoundingClientRect().top) } : null;
  }
  function sparaMinne(kort) {
    if (!grid || /\/products\//.test(location.pathname)) return;
    var a = ankare(kort);
    try {
      sessionStorage.setItem(MINNE_RUTNAT, JSON.stringify({ u: minnesUrl(), n: laddade, y: Math.round(window.scrollY), h: a && a.h, o: a && a.o, t: Date.now() }));
    } catch (e) {}
  }
  if (grid) {
    window.addEventListener("pagehide", function () { sparaMinne(); });
    document.addEventListener("click", function (e) {
      var k = e.target.closest && e.target.closest(".npx-card[data-npx-handle]");
      k && grid.contains(k) && sparaMinne(k);
    }, !0);
    (function aterstall() {
      var m = null, nav = performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
      var typ = nav ? nav.type : performance.navigation && performance.navigation.type === 2 ? "back_forward" : "";
      if (typ !== "back_forward" && typ !== "reload") return;
      try { m = JSON.parse(sessionStorage.getItem(MINNE_RUTNAT) || "null"); } catch (e) {}
      if (!m || m.u !== minnesUrl() || Date.now() - m.t > 3 * 3600 * 1000) return;
      if (!m.n && !m.y) return;
      "scrollRestoration" in history && (history.scrollRestoration = "manual");
      var mal = Math.min(m.n || 0, 40), varv = 0;
      autoLeft = Math.max(0, autoLeft - mal);
      // Laddar tills lika många sidor finns som när man lämnade; en sida som skrollvakten hämtar samtidigt räknas med.
      function nasta() {
        if (laddade >= mal || !moreBtn || ++varv > 120) return Promise.resolve();
        if (loading) return new Promise(function (ok) { setTimeout(ok, 120); }).then(nasta);
        return loadNext().then(function (mer) { return mer ? nasta() : null; });
      }
      nasta().then(function () {
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          var kort = m.h && grid.querySelector('.npx-card[data-npx-handle="' + (window.CSS && CSS.escape ? CSS.escape(m.h) : m.h) + '"]');
          var y = kort ? window.scrollY + kort.getBoundingClientRect().top - (m.o || 0) : m.y;
          window.scrollTo(0, Math.max(0, y));
        }); });
      });
    })();
  }

  window.npxExplore = {
    ersatt: ersatt,
    appendTiles: appendTiles,
    observe: observe,
    relayout: relayout,
  };
})();
